var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#443F54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8.72326 15.0231C7.92676 14.5382 6.95757 13.9498 6.16163 13.4649C5.81513 13.2574 5.43488 13.0498 5.08838 12.8074C4.95001 12.7039 4.95001 12.5998 4.95001 12.5306C5.29594 10.9039 5.67676 9.13875 6.05813 7.54575L5.81513 6.78469C5.81513 6.78469 4.98488 10.7649 4.56919 12.5306C4.50001 12.7725 4.5692 12.9114 4.81107 13.0498C6.16107 13.8458 8.89594 15.5766 8.89594 15.5766L8.72326 15.0231ZM9.38082 15.0231C10.1768 14.5382 11.1459 13.9498 11.9424 13.4649C12.2884 13.2574 12.6692 13.0498 13.0151 12.8074C13.1541 12.7039 13.1541 12.5998 13.1541 12.5306C12.8076 10.9039 12.4268 9.13875 12.0459 7.54575L12.3233 6.819C12.3233 6.819 13.1541 10.7649 13.5349 12.5306C13.6041 12.7725 13.5349 12.9114 13.2924 13.0498C11.9424 13.8458 9.20757 15.5766 9.20757 15.5766L9.38082 15.0231ZM12.0116 6.85388L11.8733 6.64575H6.26513L6.12676 6.85388C6.12676 6.85388 6.23082 7.13063 6.19595 7.02656H11.9768C11.9076 7.09575 12.0116 6.85388 12.0116 6.85388Z",
    fill: "#FEFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1849 6.5418C12.1849 6.5418 10.2808 3.77374 9.45001 2.56211C9.27676 2.35399 9.17326 2.25049 9.0692 2.25049C8.96514 2.25049 8.82733 2.35455 8.68839 2.56211C7.85758 3.73886 5.95408 6.54293 5.95408 6.54293C5.78083 6.7848 5.78083 6.85455 5.9192 7.16561C5.9192 7.16561 7.2692 10.9046 7.82326 12.5656C8.10001 13.3272 8.82676 15.5081 8.82676 15.5081C8.86164 15.5772 9.00001 15.6121 9.0692 15.6121C9.15977 15.6079 9.24573 15.5709 9.31108 15.5081C9.31108 15.5081 10.0733 13.3272 10.3151 12.5662C10.8692 10.9389 12.2192 7.16618 12.2192 7.16618C12.3576 6.85455 12.3576 6.78536 12.1849 6.54293V6.5418ZM9.0692 14.3651C8.18747 11.8514 7.31053 9.33609 6.43839 6.81911C6.43839 6.81911 8.30758 4.0848 9.03489 3.01099C9.76164 4.0848 11.6308 6.81911 11.6308 6.81911C11.6308 6.81911 9.86514 12.011 9.0692 14.3651Z",
    fill: "#FEFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEon);
export default __webpack_public_path__ + "static/media/eon.979696f9b8f826f51b851d24213f784c.svg";
export { ForwardRef as ReactComponent };